import { apiFetch } from "../../../core/utils/api";

export const SUPPORTED_ELEMENT_STYLE_PRESET_TYPES = new Set([
  "hero",
  "title",
  "text",
  "button",
  "button_collection",
  "component",
  "navbar",
  "sidebar",
  "navbar_section",
  "sidebar_section",
  "footer",
]);

async function readJsonOrThrow(response) {
  if (response.ok) {
    try {
      return await response.json();
    } catch (_) {
      return {};
    }
  }

  let text = "";
  try {
    text = await response.text();
  } catch (_) {
    text = "";
  }

  let parsed = null;
  try {
    parsed = text ? JSON.parse(text) : null;
  } catch (_) {
    parsed = null;
  }

  const message =
    parsed?.error ||
    parsed?.detail ||
    parsed?.message ||
    (typeof parsed === "string" ? parsed : null) ||
    (text && !text.trim().startsWith("{") ? text : null) ||
    `Request failed (${response.status})`;

  throw new Error(message);
}

export async function fetchElementStylePresetPreviews(elementType) {
  const response = await apiFetch(
    `/api/style-presets/elements/${elementType}/preview/`,
    {
      method: "GET",
      credentials: "include",
    },
  );
  return readJsonOrThrow(response);
}
